import React, { useRef } from "react";
import { Bold, Italic, List, ListOrdered } from "lucide-react";

// Sprint WEB.1 — Editor Markdown leggero con toolbar fissa.
// Produce Markdown (subset ristretto): **grassetto**, *corsivo*, "- " puntato,
// "1. " numerato, paragrafi. Nessun HTML, nessun link/immagine.
export const MarkdownEditor = ({ value, onChange, placeholder, testId, rows = 8, disabled = false }) => {
  const ref = useRef(null);

  const surround = (before, after = before) => {
    const ta = ref.current;
    if (!ta) return;
    const start = ta.selectionStart;
    const end = ta.selectionEnd;
    const v = value || "";
    const sel = v.slice(start, end) || "testo";
    const next = v.slice(0, start) + before + sel + after + v.slice(end);
    onChange(next);
    requestAnimationFrame(() => {
      ta.focus();
      ta.selectionStart = start + before.length;
      ta.selectionEnd = start + before.length + sel.length;
    });
  };

  const linePrefix = (prefixFn) => {
    const ta = ref.current;
    if (!ta) return;
    const start = ta.selectionStart;
    const end = ta.selectionEnd;
    const v = value || "";
    const lineStart = v.lastIndexOf("\n", start - 1) + 1;
    const lineEnd = v.indexOf("\n", end);
    const sliceEnd = lineEnd === -1 ? v.length : lineEnd;
    const block = v.slice(lineStart, sliceEnd);
    const lines = block.split("\n");
    const next = v.slice(0, lineStart) + lines.map((l, i) => prefixFn(l, i)).join("\n") + v.slice(sliceEnd);
    onChange(next);
    requestAnimationFrame(() => ta.focus());
  };

  const btn = (Icon, label, onClick, tid) => (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={label}
      aria-label={label}
      data-testid={tid}
      className="h-8 w-8 flex items-center justify-center rounded-md text-slate-600 hover:bg-slate-100 hover:text-slate-900 disabled:opacity-40 transition-colors"
    >
      <Icon className="h-4 w-4" />
    </button>
  );

  return (
    <div className="border border-slate-200 rounded-lg overflow-hidden bg-white focus-within:ring-2 focus-within:ring-blue-500/40">
      <div className="flex items-center gap-0.5 px-1.5 py-1 border-b border-slate-100 bg-slate-50">
        {btn(Bold, "Grassetto", () => surround("**"), `${testId}-bold`)}
        {btn(Italic, "Corsivo", () => surround("*"), `${testId}-italic`)}
        <span className="w-px h-5 bg-slate-200 mx-1" />
        {btn(List, "Elenco puntato", () => linePrefix((l) => (l.startsWith("- ") ? l : `- ${l}`)), `${testId}-ul`)}
        {btn(ListOrdered, "Elenco numerato", () => linePrefix((l, i) => (/^\d+\.\s/.test(l) ? l : `${i + 1}. ${l}`)), `${testId}-ol`)}
      </div>
      <textarea
        ref={ref}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        rows={rows}
        disabled={disabled}
        data-testid={testId}
        className="w-full px-3 py-2 text-sm text-slate-800 outline-none resize-y font-mono leading-relaxed disabled:bg-slate-50"
      />
    </div>
  );
};

export default MarkdownEditor;
